export const INTEGER_VALIDATION_REGEX = /^[0-9]+$/;
